"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _themeProviderUtils = require("../utils/themeProviderUtils");
var _excluded = ["className", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var styleToString = function styleToString(style) {
  return Object.entries(style).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return acc + key + ":" + value + ";";
  }, "");
};
var getVariables = function getVariables(theme) {
  var colors = Object.entries(theme.colors).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return ["--theme-colors-" + key, value];
  });
  var sizes = Object.entries(theme.iconSizes).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    return ["--theme-sizes-" + key, value + "px"];
  });
  return _objectSpread(_objectSpread({
    color: theme.colors.baseContrast090,
    "--theme-direction": theme.direction,
    "--theme-spacing-base": theme.spacing.base + "px"
  }, Object.fromEntries(colors)), Object.fromEntries(sizes));
};
var useStyles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    "@global": _defineProperty({
      "*": {
        scrollbarColor: "".concat(theme.colors.baseContrast030, " transparent")
      }
    }, ".".concat(_themeProviderUtils.THEME_WRAPPER_CLASS, ":empty"), {
      display: "none"
    })
  };
});
var ThemeProviderElement = /*#__PURE__*/(0, _react.forwardRef)(function (_ref7, ref) {
  var _theme$themeProviderP, _theme$themeProviderP2;
  var className = _ref7.className,
    children = _ref7.children,
    props = _objectWithoutProperties(_ref7, _excluded);
  var theme = (0, _reactJss.useTheme)();
  useStyles();
  var innerRef = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(ref, function () {
    return innerRef.current;
  });
  (0, _react.useEffect)(function () {
    if (innerRef.current) {
      // @ts-expect-error: version is a property that we put on the element
      innerRef.current.version = theme.version;
    }
  }, [theme.version]);

  // TODO: this should be generated by the platform
  (0, _react.useEffect)(function () {
    if (!theme.themeProviderProps) {
      return;
    }
    var platformId = theme.themeProviderProps.platformId;
    var id = "icf-" + platformId + "-" + theme.mode + "-" + theme.colors.primary;
    if (document.getElementById(id)) {
      return;
    }
    var selector = "[data-icf-platform=\"".concat(platformId, "\"][data-icf-mode=\"").concat(theme.mode, "\"][data-icf-primary=\"").concat(theme.colors.primary, "\"]");
    var element = document.createElement("style");
    element.innerText = selector + "{" + styleToString(getVariables(theme)) + "}";
    element.id = id;
    document.head.appendChild(element);
  }, [theme, (_theme$themeProviderP = theme.themeProviderProps) === null || _theme$themeProviderP === void 0 ? void 0 : _theme$themeProviderP.platformId, theme.mode, theme.colors.primary]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: innerRef,
    dir: theme.direction,
    lang: theme.language,
    "data-icf-platform": (_theme$themeProviderP2 = theme.themeProviderProps) === null || _theme$themeProviderP2 === void 0 ? void 0 : _theme$themeProviderP2.platformId,
    "data-icf-mode": theme.mode,
    "data-icf-primary": theme.colors.primary,
    className: (0, _classnames.default)(_themeProviderUtils.THEME_WRAPPER_CLASS, className)
  }, props), children);
});
ThemeProviderElement.displayName = "ThemeProviderElement";
var _default = exports.default = ThemeProviderElement;